<template>
  <div>
    <b-container id="form" fluid>
      <b-row>
        <b-col cols="auto" class="my-2">
          <multiselect
            v-model="filter.test_item"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="test_item"
            :show-labels="false"
            placeholder="Test item"
          />
        </b-col>
        <b-col cols="auto" class="my-2">
          <multiselect
            v-model="filter.qc_name"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="qc_name"
            :show-labels="false"
            placeholder="QC Name"
          />
        </b-col>
        <b-col cols="auto" class="my-2">
          <multiselect
            v-model="filter.lot_no1"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="lot_no"
            :show-labels="false"
            placeholder="Lot No. 1"
          />
        </b-col>
        <b-col cols="auto" class="my-2">
          <div
            class="datepicker-trigger input-group"
            @mouseover="activeCloseDate1 = true"
            @mouseleave="activeCloseDate1 = false"
          >
            <input
              id="datepicker-trigger-2"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="เลือกวันที่"
              :value="formatDates(filter.dateOne1, filter.dateTwo1)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
                ><fa-icon
                  :style="{
                    opacity: activeCloseDate1 ? 1 : 0,
                  }"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate1"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger-2'"
              :mode="'range'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :date-one="filter.dateOne1"
              :date-two="filter.dateTwo1"
              :close-after-select="true"
              :show-action-buttons="false"
              @date-one-selected="
                (val) => {
                  filter.dateOne1 = val;
                }
              "
              @date-two-selected="
                (val) => {
                  filter.dateTwo1 = val;
                }
              "
            />
          </div>
        </b-col>
        <b-col cols="auto" class="my-2">
          <multiselect
            v-model="filter.lot_no2"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="lot_no"
            :show-labels="false"
            placeholder="Lot No. 2"
          />
        </b-col>
        <b-col cols="auto" class="my-2">
          <div
            class="datepicker-trigger input-group"
            @mouseover="activeCloseDate2 = true"
            @mouseleave="activeCloseDate2 = false"
          >
            <input
              id="datepicker-trigger-3"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="เลือกวันที่"
              :value="formatDates(filter.dateOne2, filter.dateTwo2)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon2"
                class="input-group-text border-left-0 rounded-right bg-white"
                ><fa-icon
                  :style="{
                    opacity: activeCloseDate2 ? 1 : 0,
                  }"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate2"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger-3'"
              :mode="'range'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :date-one="filter.dateOne2"
              :date-two="filter.dateTwo2"
              :close-after-select="true"
              :show-action-buttons="false"
              @date-one-selected="
                (val) => {
                  filter.dateOne2 = val;
                }
              "
              @date-two-selected="
                (val) => {
                  filter.dateTwo2 = val;
                }
              "
            />
          </div>
        </b-col>
        <b-col
          cols="auto"
          class="justify-content-center align-self-center my-2"
        >
          <b-button
            variant="link"
            block
            class="search-icon"
            @click="plotGraph()"
          >
            <fa-icon icon="search" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-row>
      <b-col>
        <canvas
          id="myChart"
          :class="{ 'd-block': plot.length > 0, 'd-none': plot.length === 0 }"
        />
        <h2
          :class="{ 'd-block': plot.length === 0, 'd-none': plot.length > 0 }"
          style="vertical-align: center"
        >
          ไม่มีข้อมูล
        </h2>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
import format from "date-fns/format";
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";

export default {
  components: {},
  data() {
    return {
      activeCloseDate1: false,
      activeCloseDate2: false,
      filter: {
        test_item: null,
        qc_name: null,
        lot_no1: null,
        lot_no2: null,
        dateOne1: "",
        dateTwo1: "",
        dateOne2: "",
        dateTwo2: "",
      },
      drawChart: false,
      dateFormat: "YYYY/MM/DD",
    };
  },
  created() {},
  mounted() {
    var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    this.filter.dateOne1 = today;
    this.filter.dateOne2 = today;
  },
  computed: {
    ...mapGetters({
      plot: "QualityControl/getFilterQuality",
      test_item: "QualityControl/getTestItemAll",
      qc_name: "QualityControl/getQCNameAll",
      lot_no: "QualityControl/getLotNumberAll",
    }),
  },
  methods: {
    ...mapActions({
      filterQuality: "QualityControl/filterQuality",
    }),
    plotGraph() {
      this.drawChart = false;

      let payload = {
        test: this.filter.test_item,
        qcName: this.filter.qc_name,
        lots: [
          {
            "No.": this.filter.lot_no1,
            dateStart: this.filter.dateOne1,
            dateEnd: this.filter.dateTwo1,
          },
          {
            "No.": this.filter.lot_no2,
            dateStart: this.filter.dateOne2,
            dateEnd: this.filter.dateTwo2,
          },
        ],
      };
      this.filterQuality(payload);

      var ctx = document.getElementById("myChart");
      setTimeout(() => {
        new Chart(ctx, {
          type: "line",
          data: { datasets: this.plot },
          options: {
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "day",
                  },
                },
              ],
            },
          },
        });
        this.drawChart = true;
      }, 500);
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate1() {
      this.filter.dateOne1 = "";
      this.filter.dateTwo1 = "";
    },
    clearDate2() {
      this.filter.dateOne2 = "";
      this.filter.dateTwo2 = "";
    },
  },
};
</script>

<style scoped>
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center; */
  /*height: 50px;*/
  /* padding: 0.5rem; */
}
.left {
  text-align: left;
}
.search-box {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
input[type="search"] {
  margin-left: 5px;
  width: 22%;
}
.select-box {
  margin: 0px 5px 0px 5px;
  width: 20vw;
}
.search-icon {
  align-self: center;
  margin: 0px 0px 0px 10px;
  color: black;
}
.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
a {
  color: black;
  cursor: pointer;
}
.text-red {
  color: red;
}
.text-orange {
  color: orange;
}
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 15.5vw;
}
.icon {
  cursor: pointer;
}
.color {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  align-self: center;
  margin: 0 auto;
  justify-content: center;
}
.group-status {
  display: flex;
  margin-bottom: 5px;
}
.status {
  display: flex;
  margin-right: 20px;
}
.red {
  background-color: red;
}
.yellow {
  background-color: #ffe927;
}
.pink {
  background-color: pink;
}
.blue {
  background-color: #00d0ec;
}
.purple {
  background-color: #7202ec;
}
.green {
  background-color: #48e100;
}
.gray {
  background-color: gray;
}
.orange {
  background-color: #fb822b;
}
.approve-btn {
  background-color: #009906;
  border: none;
}

.reject-btn {
  background-color: #e20000;
  border: none;
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>
